import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Paper, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';

import ResourceList from '../share/ResourceList';
import { resourceFields } from '../../data/Constants';
import { commonResourceStyle } from '../../css/style';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import LoadingBar from '../share/LoadingBar';
import {
  buildUpSearchableProductsAndItems,
  convertIdsToSeparatedNames,
  searchEntity,
} from '../../utils/Functions';
import BasicToolBar from '../share/BasicToolBar';

const styles = commonResourceStyle();

class Tiers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filteredTiers: [],
      searchedTerm: null,
    };
  }

  componentDidMount = async () => {
    await this.getTiersResources();
  }

  componentDidUpdate = async (prevProps) => {
    const { apiToken } = this.props;
    if (prevProps.apiToken !== apiToken) {
      await this.getTiersResources();
    }
  }

  getTiersResources = async () => {
    const { getAllResources } = this.props.actions;
    const { getTiers } = this.props.actions;
    const { apiToken } = this.props;
    const productRes = await getAllResources(apiToken, 'products');
    let { itemNamesForIds } = buildUpSearchableProductsAndItems(productRes, true);
    this.setState({ itemNamesForIds });
    await getTiers(apiToken);
  }

  getAndFormatItemNamesFromIds = (tiers) => {
    if (!tiers) return [];
    const { itemNamesForIds } = this.state;
    const tiersWithFormattedItemList = tiers.map((tier) => {
      const tierClone = cloneDeep(tier);
      return convertIdsToSeparatedNames(tierClone, 'productItems', itemNamesForIds, '\n\r');
    });
    return tiersWithFormattedItemList;
  }

  handleSearch = (term) => {
    const { tiers } = this.props;
    const searchEntityResult = searchEntity(term, tiers, 'name');
    const formattedTiers = this.getAndFormatItemNamesFromIds(searchEntityResult);
    this.setState({
      filteredTiers: formattedTiers,
      searchedTerm: term,
    });
  }

  handleClearSearch = () => {
    this.setState({
      filteredTiers: [],
      searchedTerm: '',
    });
  }

  onClickDeleteResource = (tierId) => {
    const { actions, apiToken } = this.props;
    actions.deleteTiers(apiToken, tierId);
  }

  render() {
    const {
      tiers, actions, loading, apiToken, match,
    } = this.props;
    const { searchedTerm, filteredTiers } = this.state;

    const tiersWithFormattedItemList = this.getAndFormatItemNamesFromIds(tiers);
    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <div style={styles.container}>
            <div style={styles.resourceHeader}>
              <div style={styles.resourceName}>
                <Typography style={styles.resourceName}>Rewards</Typography>
              </div>
              <div style={styles.breadcrumbContainer}>
                <CraverBreadCrumb resource='tiers' />
              </div>
            </div>
            <Paper style={styles.paper}>
              <BasicToolBar
                actions={actions}
                resourceName="tiers"
                handleSearch={this.handleSearch}
                handleClearSearch={this.handleClearSearch}
              />
              <ResourceList
                data={searchedTerm ? filteredTiers : tiersWithFormattedItemList}
                actions={actions}
                fieldNames={resourceFields.tiers}
                onClickDeleteResource={this.onClickDeleteResource}
                resourceName="tiers"
                apiToken={apiToken}
              />
            </Paper>
          </div>
        )
    );
  }
}

export default connect(
  state => ({
    loading: state.get('loading').toJS().loading,
    tiers: state.get('tiers').toJS().tierList,
  }),
)(Tiers);